webpackJsonp([72],{

/***/ 1281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_template_vue__ = __webpack_require__(1927);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f27efbee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_template_vue__ = __webpack_require__(2416);
function injectStyle (ssrContext) {
  __webpack_require__(2409)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f27efbee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_template_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f27efbee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_template_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_button_vue__ = __webpack_require__(1376);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a59afd1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_button_vue__ = __webpack_require__(1395);
function injectStyle (ssrContext) {
  __webpack_require__(1393)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a59afd1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a59afd1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'PButton',
	props: {
		type: {
			default: function _default() {
				return 'primary';
			},
			validator: function validator(value) {
				return ['primary', 'secondary', 'black'].includes(value);
			}
		},
		extended: {
			default: function _default() {
				return false;
			}
		},
		outlined: {
			default: function _default() {
				return false;
			}
		},
		disabled: {
			default: function _default() {
				return false;
			}
		},
		minWidth: {
			default: function _default() {
				return 'auto';
			}
		},
		roundedLevel: {
			default: function _default() {
				return 'rounded-full';
			},
			validator: function validator(value) {
				return ['rounded', 'rounded-full'].includes(value);
			}
		},
		size: {
			default: 'normal',
			validator: function validator(value) {
				return ['xsmall', 'small', 'normal', 'large'].includes(value);
			}
		}
	},
	computed: {
		customClass: function customClass() {
			return [{
				primary: this.type === 'primary',
				secondary: this.type === 'secondary',
				black: this.type === 'black',
				outlined: this.outlined
			}, this.extended ? 'custom-button--px-14' : 'custom-button--px-8', this.roundedLevel === 'rounded' ? 'custom-button-rounded' : '', this.roundedLevel === 'rounded-full' ? 'custom-button-rounded-full' : '', this.size === 'xsmall' ? 'v-btn--xsmall custom-button--xsmall' : '', this.size === 'small' ? 'v-btn--small custom-button--small' : '', this.size === 'large' ? 'v-btn--large custom-button--large' : '', this.disabled ? 'v-btn--disabled' : ''];
		}
	}
});

/***/ }),

/***/ 1393:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1394);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("e5b9defa", content, true, {});

/***/ }),

/***/ 1394:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.custom-button--px-8[data-v-4a59afd1]{padding-left:2rem!important;padding-right:2rem!important}.custom-button--px-14[data-v-4a59afd1]{padding-left:3.5rem!important;padding-right:3.5rem!important}", "", {"version":3,"sources":["/opt/build/repo/src/modules/shared/components/ui/p-button.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,sCACE,4BAA8B,AAC9B,4BAA+B,CAChC,AACD,uCACE,8BAAgC,AAChC,8BAAiC,CAClC","file":"p-button.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.custom-button--px-8[data-v-4a59afd1] {\n  padding-left: 2rem !important;\n  padding-right: 2rem !important;\n}\n.custom-button--px-14[data-v-4a59afd1] {\n  padding-left: 3.5rem !important;\n  padding-right: 3.5rem !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"custom-button v-btn",class:_vm.customClass,style:({ minWidth: _vm.minWidth }),attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'title-header',
	props: {
		gray: {
			type: Boolean,
			default: false
		},
		pbZero: {
			type: Boolean,
			default: false
		},
		pollName: String,
		title: String,
		urlImage: String
	}
});

/***/ }),

/***/ 1487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_title_header_vue__ = __webpack_require__(1460);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdbead12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_title_header_vue__ = __webpack_require__(1490);
function injectStyle (ssrContext) {
  __webpack_require__(1488)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bdbead12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_title_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdbead12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_title_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1488:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1489);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("6a611bf6", content, true, {});

/***/ }),

/***/ 1489:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.title-header .text[data-v-bdbead12]{font-family:NeuzeitGroTBold;font-size:18px}.title-header .wrapper[data-v-bdbead12]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:1px solid #e7e7e7;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 5px 10px}.title-header .wrapper.pb-0[data-v-bdbead12]{padding-bottom:0}.subtitle-header[data-v-bdbead12]{font-family:NeuzeitGroT;font-size:18px}", "", {"version":3,"sources":["/opt/build/repo/src/components/diagnosis/title-header.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,qCACE,4BAA+B,AAC/B,cAAgB,CACjB,AACD,wCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gCAAiC,AACjC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,kBAAoB,CACrB,AACD,6CACI,gBAAoB,CACvB,AACD,kCACE,wBAA2B,AAC3B,cAAgB,CACjB","file":"title-header.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.title-header .text[data-v-bdbead12] {\n  font-family: \"NeuzeitGroTBold\";\n  font-size: 18px;\n}\n.title-header .wrapper[data-v-bdbead12] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-bottom: 1px solid #e7e7e7;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 5px 10px;\n}\n.title-header .wrapper.pb-0[data-v-bdbead12] {\n    padding-bottom: 0px;\n}\n.subtitle-header[data-v-bdbead12] {\n  font-family: \"NeuzeitGroT\";\n  font-size: 18px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-header"},[_c('div',{staticClass:"wrapper",class:{ 'pb-0': _vm.pbZero }},[_c('div',[(_vm.urlImage)?_c('img',{staticClass:"mr-2",attrs:{"src":_vm.urlImage,"alt":_vm.urlImage}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text",style:(("color:" + (_vm.gray ? _vm.$appColors.info : _vm.$appColors.primary)))},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.title)+" "),(_vm.pollName)?_c('span',{staticClass:"subtitle-header"},[_vm._v("- "+_vm._s(_vm.pollName))]):_vm._e()])]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_shared_components_ui_p_button__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_diagnosis_title_header__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_configuration_report_template_selector_assign_template__ = __webpack_require__(2411);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'report-template',
	components: {
		PButton: __WEBPACK_IMPORTED_MODULE_4__modules_shared_components_ui_p_button__["a" /* default */],
		titleHeader: __WEBPACK_IMPORTED_MODULE_5__components_diagnosis_title_header__["a" /* default */],
		selectorAssignTemplate: __WEBPACK_IMPORTED_MODULE_6__components_configuration_report_template_selector_assign_template__["a" /* default */]
	},
	data: function data() {
		return {
			templates: [],
			indexTab: 0,
			columns: [{
				id: 1,
				name: 'Código',
				value: 'code',
				visible: true,
				checked: true,
				sortCheck: true,
				fieldName: 'code',
				color: 'gray'
			}, {
				id: 2,
				name: 'Nombre',
				value: 'name',
				visible: true,
				checked: true,
				sortCheck: true,
				fieldName: 'name',
				color: 'gray'
			}],
			params: {
				limit: 10,
				page: 1
			},
			currentPage: 1,
			totalItems: 0,
			lastPage: 1,
			checkAll: false,
			dataSelected: []
		};
	},
	created: function created() {
		this.loadTemplates();
	},

	methods: {
		loadTemplates: function loadTemplates() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
				var params, _ref, response, headers;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.params);
								_context.prev = 1;
								_context.next = 4;
								return _this.$httpPraktiko.get('templates/company', { params: params });

							case 4:
								_ref = _context.sent;
								response = _ref.data;
								headers = _ref.headers;

								_this.templates = response;
								_this.lastPage = Number(headers['x-last-page']);
								_this.totalItems = Number(headers['x-quantity']);
								_context.next = 15;
								break;

							case 12:
								_context.prev = 12;
								_context.t0 = _context['catch'](1);

								_this.showGenericError();

							case 15:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this, [[1, 12]]);
			}))();
		},
		loadTemplateAssign: function loadTemplateAssign() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var params, _ref2, response, headers;

				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.params);
								_context2.prev = 1;
								_context2.next = 4;
								return _this2.$httpPraktiko.get('/templates/assign-company', { params: params });

							case 4:
								_ref2 = _context2.sent;
								response = _ref2.data;
								headers = _ref2.headers;

								_this2.templates = response;
								_this2.lastPage = Number(headers['x-last-page']);
								_this2.totalItems = Number(headers['x-quantity']);
								_context2.next = 15;
								break;

							case 12:
								_context2.prev = 12;
								_context2.t0 = _context2['catch'](1);

								_this2.showGenericError();

							case 15:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2, [[1, 12]]);
			}))();
		},
		changePage: function changePage(page) {
			this.params.page = page;
			this.currentPage = page;
			if (this.indexTab === 0) {
				this.loadTemplates();
			} else {
				this.loadTemplateAssign();
			}
		},
		onSearchEvent: function onSearchEvent(search) {
			this.params.search = search.trim() || null;
			this.changePage(1);
		},
		changeColor: function changeColor(fieldName) {
			var _this3 = this;

			this.columns.forEach(function (c, index) {
				if (c.fieldName !== fieldName && c.color) {
					_this3.$set(_this3.columns, index, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, c, { color: 'gray' }));
				}
			});
		},
		changeSort: function changeSort(_ref3) {
			var fieldName = _ref3.fieldName,
			    sortDirection = _ref3.sortDirection;

			this.params.sortField = fieldName;
			this.params.sortDirection = sortDirection;
			this.loadTemplates();
		},
		rowIsSelected: function rowIsSelected(value) {
			if (value.isSelected) {
				this.dataSelected.push(value);
			} else {
				var index = this.dataSelected.findIndex(function (d) {
					return d.id === value.id;
				});
				if (index > -1) {
					this.dataSelected.splice(index, 1);
				}
			}
			this.checkAll = this.templates.every(function (e) {
				return e.isSelected;
			});
		},
		selectedAll: function selectedAll(value) {
			this.templates = this.templates.map(function (r) {
				var newRow = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, r);
				newRow.isSelected = value;
				return newRow;
			});
			this.checkAll = value;
			this.dataSelected = value ? [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.templates)) : [];
		},
		assingTemplates: function assingTemplates() {
			var _this4 = this;

			return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
				var dataReestructured, body;
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								dataReestructured = _this4.dataSelected.map(function (_ref4) {
									var code = _ref4.code,
									    name = _ref4.name,
									    template = _ref4.template,
									    id = _ref4.id;
									return { code: code, name: name, template: template, templateId: id };
								});
								body = {
									templates: dataReestructured
								};
								_context3.prev = 2;
								_context3.next = 5;
								return _this4.$httpPraktiko.post('templates/company', body);

							case 5:
								_this4.showNotification('Plantillas Asignadas Correctamente');
								_this4.loadTemplates();
								_context3.next = 12;
								break;

							case 9:
								_context3.prev = 9;
								_context3.t0 = _context3['catch'](2);

								_this4.showGenericError();

							case 12:
								_context3.prev = 12;

								_this4.dataSelected = [];
								return _context3.finish(12);

							case 15:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this4, [[2, 9, 12, 15]]);
			}))();
		},
		handlerTypeAssign: function handlerTypeAssign(index) {
			this.indexTab = index;
			if (this.indexTab === 0) {
				this.loadTemplates();
			} else {
				this.loadTemplateAssign();
			}
		}
	},
	watch: {
		indexTab: {
			handler: function handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dataSelected = [];
				}
			}
		}
	}
});

/***/ }),

/***/ 1928:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_configuration_report_template_constant__ = __webpack_require__(2414);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'selector-assign-template',
	data: function data() {
		return {
			ASSIGN_TYPES: __WEBPACK_IMPORTED_MODULE_0__components_configuration_report_template_constant__["a" /* ASSIGN_TYPES */],
			selectedTabIndex: 0
		};
	},

	props: ['indexTab'],
	methods: {
		handleTabClick: function handleTabClick(index) {
			this.$emit('typeAssign', index);
		}
	},
	watch: {
		indexTab: {
			handler: function handler(newVal) {
				this.selectedTabIndex = newVal;
			}
		}
	}
});

/***/ }),

/***/ 2409:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2410);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("ecef9e0c", content, true, {});

/***/ }),

/***/ 2410:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}", "", {"version":3,"sources":["/opt/build/repo/src/pages/configuration/report-template.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB","file":"report-template.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selector_assign_template_vue__ = __webpack_require__(1928);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51641e65_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selector_assign_template_vue__ = __webpack_require__(2415);
function injectStyle (ssrContext) {
  __webpack_require__(2412)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selector_assign_template_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51641e65_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selector_assign_template_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2412:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2413);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("9ffa2de2", content, true, {});

/***/ }),

/***/ 2413:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.type-active-jobs .v-tabs__bar{background:transparent!important}.type-active-jobs .v-tabs__bar .v-tabs__slider-wrapper .accent{background:var(--app-color-primary)!important}.type-active-jobs .v-tabs__bar .v-tabs__container{height:30px!important}.type-active-jobs .v-tabs__bar .v-tabs__container .v-tabs__div{color:var(--app-color-primary)!important}", "", {"version":3,"sources":["/opt/build/repo/src/components/configuration/report-template/selector-assign-template.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,+BACE,gCAAmC,CACpC,AACD,+DACI,6CAAgD,CACnD,AACD,kDACI,qBAAwB,CAC3B,AACD,+DACM,wCAA2C,CAChD","file":"selector-assign-template.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.type-active-jobs .v-tabs__bar {\n  background: transparent !important;\n}\n.type-active-jobs .v-tabs__bar .v-tabs__slider-wrapper .accent {\n    background: var(--app-color-primary) !important;\n}\n.type-active-jobs .v-tabs__bar .v-tabs__container {\n    height: 30px !important;\n}\n.type-active-jobs .v-tabs__bar .v-tabs__container .v-tabs__div {\n      color: var(--app-color-primary) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASSIGN_TYPES; });
var ASSIGN_TYPES = [{
	label: 'Por Asignar',
	key: 1
}, {
	label: 'Asignados',
	key: 0
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),

/***/ 2415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{staticClass:"type-active-jobs",on:{"input":_vm.handleTabClick},model:{value:(_vm.selectedTabIndex),callback:function ($$v) {_vm.selectedTabIndex=$$v},expression:"selectedTabIndex"}},_vm._l((_vm.ASSIGN_TYPES),function(jobsType,index){return _c('v-tab',{key:index},[_c('b',[_vm._v(_vm._s(jobsType.label))])])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title-header',{staticClass:"tw-mb-4"},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":"","align-center":""}},[_c('div',{staticClass:"wrapper-btns"},[_c('p-button',{attrs:{"disabled":this.indexTab === 1 || this.dataSelected.length === 0,"type":"primary"},on:{"click":_vm.assingTemplates}},[_vm._v("Asignar Plantillas")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"tw-flex tw-w-full tw-justify-end"},[_c('selector-assign-template',{attrs:{"index-tab":_vm.indexTab},on:{"typeAssign":_vm.handlerTypeAssign}})],1),_vm._v(" "),_c('app-table',{staticClass:"mt-3 no-main-list",attrs:{"columns":_vm.columns,"filter-columns":false,"rows":_vm.templates,"items-quantity":_vm.templates.length,"items-total-quantity":_vm.totalItems,"current-page":_vm.currentPage,"last-page":_vm.lastPage,"check-all":_vm.checkAll,"selectable":""},on:{"on-page":_vm.changePage,"on-search-event":_vm.onSearchEvent,"changeSort":_vm.changeSort,"changeColor":_vm.changeColor,"row-is-selected":_vm.rowIsSelected,"on-selected-all":_vm.selectedAll},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticStyle:{"width":"50%","text-align":"left","padding-left":"20px"}},[_vm._v(_vm._s(props.row.code))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}],staticStyle:{"width":"50%"}},[_vm._v(_vm._s(props.row.name))])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/72.b41a23ae3cae613b479f.js